import { render } from "./GroupAdminRegisteration.vue?vue&type=template&id=54a07720&ts=true"
import script from "./GroupAdminRegisteration.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupAdminRegisteration.vue?vue&type=script&setup=true&lang=ts"

import "./GroupAdminRegisteration.vue?vue&type=style&index=0&id=54a07720&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/admin/GroupAdminRegisteration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54a07720"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54a07720', __exports__)) {
    console.log('reload')
    api.reload('54a07720', __exports__)
  }
  
  module.hot.accept("./GroupAdminRegisteration.vue?vue&type=template&id=54a07720&ts=true", () => {
    console.log('re-render')
    api.rerender('54a07720', render)
  })

}


export default __exports__